import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {GridDataResult} from '@progress/kendo-angular-grid';
import {ApiService} from '../api';
import {Exercise} from '../../models/exercise.model';

@Injectable()
export class ExerciseService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;
  public exercises:Exercise[] = [];

  constructor(private api: ApiService) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));

    this.subscription = this.api.getResource<Exercise[]>(`/exercise`, new HttpParams())
      .subscribe(result => {
        this.exercises = result;
        super.next({total:this.exercises.length,data:this.exercises.slice(0,4)});
      });

  }

  public getList( page: number, limit: number ) {
    super.next({total:this.exercises.length, data:this.exercises.slice(page * limit, page * limit  + limit)});
  }


}
